import { Building2, GitCompare, History, IndianRupee, LayoutDashboard, ListChecks, MessagesSquare, Receipt, Settings, Sparkles, UserCog, Users } from "lucide-react";

export const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, m: null, key: "dashboard" },
  { to: "/chat", label: "MOM Chat", icon: MessagesSquare, m: "chat", key: "chat" },
  { to: "/leads", label: "Leads", icon: Users, m: "leads", key: "leads" },
  { to: "/properties", label: "Properties", icon: Building2, m: "properties", key: "properties" },
  { to: "/tasks", label: "Tasks", icon: ListChecks, m: "tasks", key: "tasks" },
  { to: "/plans", label: "AI Action Plan", icon: Sparkles, m: "chat", key: "plans" },
  { to: "/matches", label: "Matchmaking", icon: GitCompare, m: "leads", key: "matches" },
  { to: "/expenses", label: "Expenses", icon: Receipt, m: "finance", key: "expenses" },
  { to: "/deals", label: "Sales & Profit", icon: IndianRupee, m: "finance", key: "deals" },
  { to: "/users", label: "Team", icon: UserCog, m: "users", key: "users" },
  { to: "/activity", label: "Activity log", icon: History, m: "activity", key: "activity" },
  { to: "/settings", label: "Settings", icon: Settings, m: null, key: "settings" },
];
